import type {ItemPickerInputMethod} from '@github-ui/item-picker-base/ItemPicker'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {useCallback} from 'react'

export type IssueViewerItemPicker =
  | 'assignees'
  | 'issue_type'
  | 'labels'
  | 'milestone'
  | 'project_iteration'
  | 'project_multi_select'
  | 'project_single_select'

export function useItemPickerActivationAnalytics(picker: IssueViewerItemPicker) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  return useCallback(
    (inputMethod: ItemPickerInputMethod) => {
      sendClickAnalyticsEvent({
        category: 'ISSUE_VIEWER',
        action: 'item_picker.activate_item',
        label: `input_method:${inputMethod};picker:${picker};`,
      })
    },
    [picker, sendClickAnalyticsEvent],
  )
}
